export default {
  practiceTrain_num_submit: '{submitCount} people has submitted',
  practiceTrain_ckeck_summary: 'Click the week to view the corresponding weekly summary',
  practiceTrain_training_category: 'Type of training:',
  practiceTrain_submit_count: '{submitCount} people has submitted',
  practiceTrain_daily_report: 'Click the date to view the corresponding daily report',
  practiceTrain_student: 'Student',
  practiceTrain_director: 'Instructor',
  practiceTrain_instructor: 'Instructor',
  practiceTrain_rotation: 'Work shift',
  practiceTrain_mentor_program: 'Instructor program',
  practiceTrain_action_learn: 'Practices',
  practiceTrain_personal_develop_plan: 'Personal development plan',
  practiceTrain_manager: 'Supervisor',
  practiceTrain_director_plan_task: 'Department head',
  practiceTrain_train_title01: 'Probation Period Work Record Form',
  practiceTrain_train_title02: 'Daily report (Newcomer daily summary)',
  practiceTrain_train_title03: 'Weekly report (Newcomer weekly summary)',
  practiceTrain_train_title04: 'Monthly report (Interview follow-up form)',
  practiceTrain_train_title05: 'Mentor evaluation form',
  practiceTrain_train_fillCard01: 'View the stage work plan arranged by the instructor',
  practiceTrain_train_fillCard02: 'Daily report should be filled in during training',
  practiceTrain_train_fillCard03: 'Weekly report should be filled in during training',
  practiceTrain_train_fillCard04: 'Monthly report should be filled in during training',
  practiceTrain_train_fillCard05: 'Please fill in the evaluation of the instructor',
  practiceTrain_mentor_title01: 'Instructor task list',
  practiceTrain_mentor_title02: 'Probation Period Work Record Form',
  practiceTrain_mentor_title03: 'Daily report (Newcomer daily summary)',
  practiceTrain_mentor_title04: 'Weekly report (Newcomer weekly summary)',
  practiceTrain_mentor_title05: 'Monthly report (Interview follow-up form)',
  practiceTrain_mentor_title06: 'Conversion evaluation form',
  practiceTrain_mentor_fillCard01: 'The instructor is required to fill in the progress of the task in stages',
  practiceTrain_mentor_fillCard02: 'The instructor is required to fill in the work plan for students',
  practiceTrain_mentor_fillCard03: 'View daily reports submitted by students',
  practiceTrain_mentor_fillCard04: 'View weekly reports submitted by students',
  practiceTrain_mentor_fillCard05: 'The instructor is required to fill in the student evaluation report',
  practiceTrain_mentor_fillCard06: 'The instructor is required to fill in the regularization comment',
  practiceTrain_manager_title01: 'Monthly report (Interview follow-up form)',
  practiceTrain_manager_fillCard01: 'Review the monthly report submitted by the student and the opinions of the instructor',
  practiceTrain_director_title01: 'Monthly report (Interview follow-up form)',
  practiceTrain_director_title02: 'Conversion evaluation form',
  practiceTrain_director_fillCard01: 'Review the monthly report submitted by the student and the opinions of the instructor',
  practiceTrain_director_fillCard02: 'The department lead is required to fill in the regularization comment',
  practiceTrain_train02_title01: 'Participant development plan form',
  practiceTrain_train02_title02: 'Participant development plan form',
  practiceTrain_train02_title03: 'Participant development plan form',
  practiceTrain_train02_fillCard01: 'Fill in the development plan and reflection for each stage of the training period',
  practiceTrain_train02_fillCard02: 'Fill in the development plan and reflection for each stage of the training period',
  practiceTrain_train02_fillCard03: 'Fill in the development plan and reflection for each stage of the training period',
  mentor02_title01: 'Participant development plan form',
  mentor02_title02: 'Participant development plan form',
  mentor02_fillCard01: "The isntructor is required to fill in an evaluation of the student's plan",
  mentor02_fillCard02: "The isntructor is required to fill in an evaluation of the student's plan",
  manager02_title01: 'Supervisor evaluation form (pre-test)',
  manager02_title02: 'Supervisor evaluation form (post-test)',
  manager02_fillCard01: 'The supervisor is required to fill in the evaluation for the student before the training',
  manager02_fillCard03: 'The supervisor is required to fill in the evaluation for the student after the training',
  practiceTrain_leave_page01: 'Evaluation form (pre-assessment)',
  practiceTrain_leave_page02: 'Evaluation form (post-assessment)',
  practiceTrain_leave_page03: 'Phase planning and reflection review',
  practiceTrain_leave_page04: 'Reflection of overall implementation',
  practiceTrain_leave_page05: 'Planning',
  practiceTrain_manager_plan_task: 'Participant development plan form',
  practiceTrain_manager_name: "Instructor's name:",
  practiceTrain_current_evaluable: 'Currently available for evaluation',
  practiceTrain_currently_review: 'Currently available for review',
  practiceTrain_people: "{notAuditCount} people",
  practiceTrain_instructor_comment: 'The instructor is required to fill in an evaluation of the student',
  practiceTrain_training_feedback: 'Training program post feedback',
  practiceTrain_month_num: "Month {monthlyNumber}",
  practiceTrain_week_num: 'Week {weeklyNumber}',
  practiceTrain_week_End: 'Week {weeklyNumber}({time})',
  practiceTrain_train_time: "Training time: "

}
